import { string } from 'yup';

const password = string().max(255, 'Password must be 255 characters or less').min(8, 'Password must be 8 characters or more');
export { password };
